/**
 * The shared TanStack Query client configuration.
 *
 * Freshness on the platform comes from **push invalidation** (see `stream.ts`),
 * not from window-focus refetching — this is an operations product, not a
 * consumer app. So focus refetching is off and stale time is modest; the SSE
 * stream invalidates the exact queries that changed.
 */
import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./mutator";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000, // 30s; push invalidates sooner when data changes
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
        retry: (failureCount, error) => {
          // Never retry a client error (4xx) — it won't fix itself.
          if (
            error instanceof ApiError &&
            error.status >= 400 &&
            error.status < 500
          ) {
            return false;
          }
          return failureCount < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}
